import React from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import { ConfirmationContainer, ConfirmationMessage } from '../../css';
import { useLocaleContext } from '../../../../../context/LocaleContext';

import EN from '../../../../../../EN.json';
import FR from '../../../../../../FR.json';

const Confirmation = ({ fileName, setConfirmDelete, onDeleteFile }) => {
  const locale = useLocaleContext();
  const {
    USERS: {
      LIST: {
        confirmationDialog: { CONFIRM, CANCEL }
      }
    },
    general: { confirmDeleteMessage }
  } = locale === 'en-US' ? EN : FR;

  return (
    <ConfirmationContainer>
      <ConfirmationMessage>{`${confirmDeleteMessage} ${fileName}?`}</ConfirmationMessage>
      <Button onClick={onDeleteFile}>{CONFIRM}</Button>
      <Button
        onClick={() => {
          setConfirmDelete(false);
        }}
      >
        {CANCEL}
      </Button>
    </ConfirmationContainer>
  );
};

Confirmation.propTypes = {
  fileName: PropTypes.string.isRequired,
  setConfirmDelete: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired
};

export default Confirmation;
